import React from 'react';
import { BodyType } from '../types/diet';

interface BodyTypeSelectorProps {
  bodyTypes: BodyType[];
  selectedType: string | undefined;
  onSelect: (typeId: string) => void;
  gender: 'male' | 'female';
}

export function BodyTypeSelector({ bodyTypes, selectedType, onSelect, gender }: BodyTypeSelectorProps) {
  const filteredTypes = bodyTypes.filter(type => type.gender === gender);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {filteredTypes.map((type) => (
        <div
          key={type.id}
          className={`relative rounded-xl overflow-hidden cursor-pointer transition-all ${
            selectedType === type.id
              ? 'ring-4 ring-custom-orange-400 scale-[1.02]'
              : 'hover:scale-[1.01]'
          }`}
          onClick={() => onSelect(type.id)}
        >
          <div className="aspect-[3/4] relative">
            <img
              src={type.image}
              alt={type.name}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
              <h3 className="font-semibold text-lg">{type.name}</h3>
              <p className="text-sm text-gray-200">Inspired by {type.celebrity}</p>
            </div>
            {selectedType === type.id && (
              <div className="absolute inset-0 bg-custom-orange-400/20 flex items-center justify-center">
                <div className="bg-white text-custom-orange-500 px-4 py-2 rounded-full font-semibold shadow-lg">
                  Selected
                </div>
              </div>
            )}
          </div>
          <div className="p-4 bg-white">
            <p className="text-sm text-gray-600">{type.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}